module.exports = __webpack_public_path__ + "static/media/brankica.8db785a4.gif";